import { useState, useCallback } from "react"
import PropTypes from "prop-types"
import { map, isEmpty } from "lodash"
import { Tooltip, ClickAwayListener, List, ListItem, ListItemText, Chip } from "@mui/material"
import { Layers } from "@mui/icons-material"

const BundleChip = ({ datasets }) => {
  const [open, setOpen] = useState(false)
  const Title = useCallback(() => <List>
    {map(datasets, ({ id, name }, index) => (
      <ListItem key={`${id}-${index}`}>
        <ListItemText primary={name} />
      </ListItem>
    ))}
  </List>, [datasets])

  if (isEmpty(datasets)) { return null }
  return <ClickAwayListener onClickAway={() => setOpen(false)}>
    <Tooltip
      placement="right-start"
      slotProps={{
        popper: { disablePortal: true },
      }}
      classes={{
        tooltip: "bundle-tooltip",
        popper: "bundle-popper",
      }}
      onClose={() => setOpen(false)}
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={<Title />}
    >
      <Chip
        className="bundle-chip"
        avatar={<Layers />}
        label="Bundle"
        clickable
        onClick={(e) => { e.stopPropagation(); setOpen(!open) }}
      />
    </Tooltip>
  </ClickAwayListener>
}

BundleChip.propTypes = {
  datasets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
}

export default BundleChip
